module.exports = __webpack_public_path__ + "static/media/challenge-background-tasks-flowers.d24fa1ae.svg";